const modifySearch = function ({ commit, state }, newValues) {
  commit("UPDATE_SEARCH", newValues);
};

export default modifySearch;
